import axios from "../http";

let module = "/sysSetting";

function selectSetting(data) {
    return axios.get(module + '/' +data);
}

function updateSetting(data) {
    return axios.put(module, data);
}


export default {
    selectSetting,updateSetting
}
